(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dez-facets-amatora"] && !Shopify.designMode) return;
  try {
    (function dezFacetsPanels() {
    const PANEL = '.facets--horizontal details.facets__panel';

    // Si el chip esta abajo en la pantalla, el panel se abre fuera de la
    // vista. En movil se desplaza lo justo para que quede completo.
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.matches(PANEL) || window.innerWidth >= 750) return;

        const content = details.querySelector('.facets__panel-content');
        requestAnimationFrame(() => content?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector(`${PANEL}[open]`);
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dez-video-diferido"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dezVideoDiferido) return;
    window.__dezVideoDiferido = true;

    function play(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function init() {
      var videos = document.querySelectorAll('video[data-dez-lazy]:not([data-dez-lazy-on])');
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.setAttribute('data-dez-lazy-on', ''); play(v); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { rootMargin: '200px 0px' });

      videos.forEach(function (v) {
        v.setAttribute('data-dez-lazy-on', '');
        v.muted = true;
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
